function getReviewTimestamp(card) {
  const timestamp = Number(card.dataset.reviewTimestamp);
  if (Number.isFinite(timestamp) && timestamp > 0) {
    return timestamp;
  }

  const rawDate = card.dataset.reviewRaw;
  if (!rawDate) {
    return 0;
  }

  const parsed = Date.parse(rawDate);
  return Number.isNaN(parsed) ? 0 : parsed / 1000;
}

function sortReviewCards(section) {
  const track = section.querySelector('.tr-track');
  if (!track) {
    return;
  }

  const limit = parseInt(section.dataset.reviewsLimit, 10) || 25;
  const cards = [...track.querySelectorAll('.tr-card')];

  cards.sort((a, b) => getReviewTimestamp(b) - getReviewTimestamp(a));

  cards.forEach((card, index) => {
    if (index >= limit) {
      card.remove();
      return;
    }

    track.appendChild(card);
  });

  const viewport = section.querySelector('.tr-viewport');
  if (viewport) {
    viewport.scrollLeft = 0;
  }
}

class TyyniReviewsSlider {
  constructor(root) {
    this.root = root;
    this.viewport = root.querySelector('.tr-viewport');
    this.track = root.querySelector('.tr-track');
    this.prev = root.querySelector('.tr-nav--prev');
    this.next = root.querySelector('.tr-nav--next');

    if (!this.viewport || !this.track || !this.prev || !this.next) {
      return;
    }

    this.prev.addEventListener('click', () => this.scroll(-1));
    this.next.addEventListener('click', () => this.scroll(1));
    this.viewport.addEventListener('scroll', () => this.updateNav(), { passive: true });
    window.addEventListener('resize', () => this.updateNav());

    this.viewport.scrollLeft = 0;
    this.updateNav();

    requestAnimationFrame(() => {
      this.viewport.scrollLeft = 0;
      this.updateNav();
    });
  }

  step() {
    const card = this.track.querySelector('.tr-card');
    if (!card) {
      return 280;
    }

    const gap = parseFloat(getComputedStyle(this.track).gap) || 16;
    return card.offsetWidth + gap;
  }

  scroll(direction) {
    this.viewport.scrollBy({
      left: this.step() * direction,
      behavior: 'smooth',
    });
  }

  updateNav() {
    const maxScroll = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
    const atStart = this.viewport.scrollLeft <= 1;
    const atEnd = this.viewport.scrollLeft >= maxScroll - 1;

    this.prev.disabled = atStart;
    this.next.disabled = atEnd || maxScroll <= 0;
  }
}

function initTyyniReviews() {
  document.querySelectorAll('[data-tyyni-reviews]').forEach((section) => {
    sortReviewCards(section);

    const slider = section.querySelector('.tr-slider');
    if (slider) {
      new TyyniReviewsSlider(slider);
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initTyyniReviews);
} else {
  initTyyniReviews();
}

document.addEventListener('shopify:section:load', (event) => {
  const section = event.target.querySelector('[data-tyyni-reviews]');
  if (!section) {
    return;
  }

  sortReviewCards(section);

  const slider = section.querySelector('.tr-slider');
  if (slider) {
    new TyyniReviewsSlider(slider);
  }
});
